export default __webpack_public_path__ + "static/media/son-of-sam.8850d2f1.jpg";